import {actionCreator} from "../../helpers/actionCreator";
import * as ActionTypes from "./types";

export const setUserLanguage = actionCreator(ActionTypes.SET_USER_LANGUAGE)